'use client'

import { PROVIDER_ROUTES, ROUTES } from '@/core/constants/routes'
import { useAuth } from '@/core/store/auth'
import { NavbarItem } from '@heroui/navbar'
import { useTranslations } from 'next-intl'
import { NavLink } from '../atoms/nav-link'

type NavLink = {
  label: string
  href: string
}

const navLinkClasses = {
  active: 'underline decoration-2 underline-offset-5',
  inactive: 'group relative transition-all duration-200',
  main: 'text-lg',
}

const NavLinkItem = ({ label, href }: NavLink) => (
  <NavbarItem>
    <NavLink exact href={href} className={navLinkClasses}>
      <span className='transition-opacity group-hover:opacity-80'>{label}</span>
      <span className='absolute bottom-0 left-0 h-px w-0 bg-current transition-all duration-300 group-hover:w-full'></span>
    </NavLink>
  </NavbarItem>
)

export const NavLinks = () => {
  const t = useTranslations()
  const { isAuthenticated } = useAuth()
  const navLinks = [
    { label: t('links.home'), href: ROUTES.home },
    { label: t('links.contact'), href: ROUTES.contactUs },
    ...(isAuthenticated
      ? []
      : [{ label: t('links.provider'), href: PROVIDER_ROUTES.login }]),
  ]

  return navLinks.map(link => <NavLinkItem key={link.href} {...link} />)
}
